module.exports = __webpack_public_path__ + "fonts/Quicksand-300-latin3.7b81366.woff2";